import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { themes } from './theme';
import TimerRoomPage from "./pages/TimerRoomPage";
import LoginPage from "./pages/LoginPage";
import AccountPage from "./pages/AccountPage"; // Make sure to import your new AccountPage

// Theme Root handles theming across all routes
function ThemeRoot({ children }) {
  const [themeKey, setThemeKey] = useState(() => {
    return localStorage.getItem("themeKey") || "coffee";
  });

  useEffect(() => {
    localStorage.setItem("themeKey", themeKey);
    const bg = themes[themeKey]?.colors?.background || "#ffffff";
    const text = themes[themeKey]?.colors?.text || "#000000";
    document.documentElement.style.setProperty("--app-bg", bg);
    document.documentElement.style.setProperty("--app-text", text);
    document.body.style.backgroundColor = bg;
    document.body.style.color = text;
  }, [themeKey]);

  return typeof children === "function"
    ? children({ themeKey, setThemeKey })
    : children;
}

// ---- Render the routes ----
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <ThemeRoot>
              {({ themeKey, setThemeKey }) => (
                <App themeKey={themeKey} setThemeKey={setThemeKey} themes={themes} />
              )}
            </ThemeRoot>
          }
        />
        <Route
          path="/room/:roomId"
          element={
            <ThemeRoot>
              {({ themeKey, setThemeKey }) => (
                <TimerRoomPage
                  themeKey={themeKey}
                  setThemeKey={setThemeKey}
                  themes={themes}
                />
              )}
            </ThemeRoot>
          }
        />
        <Route
              path="/login"
              element={
                <ThemeRoot>
                  {({ themeKey, setThemeKey }) => (
                    <LoginPage
                      theme={themes[themeKey]}
                      themeKey={themeKey}
                      setThemeKey={setThemeKey}
                      themes={themes}
                    />
                  )}
                </ThemeRoot>
              }
            />

          <Route
          path="/account"
          element={
            <ThemeRoot>
              {({ themeKey, setThemeKey }) => (
                <AccountPage themeKey={themeKey} themes={themes} />
              )}
            </ThemeRoot>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
